export type UrgentMessageModalProps = {
  onCloseModal: () => void
}

export type UrgentMessage = {
  showMessageInProd: boolean
  showMessageInStaging: boolean
  showMessageInDev: boolean
  messageId: number
  headerText: string
  descriptionText: string
  urlHeaderText: string
  noUrlText: string
  urlButtonText: string
  urlLink: string
  displayUrl: string
  qrCodeImageUrl: string
  dismissButtonTextMobile: string
  dismissButtonTextCtv: string
  webMessageBackgroundColor: string
  webMessageTextColor: string
  webMessageHeightPercent: number
}

export enum UrgentMessageKeys {
  SHOW_MESSAGE_IN_PROD = 'showMessageInProd',
  SHOW_MESSAGE_IN_STAGING = 'showMessageInStaging',
  SHOW_MESSAGE_IN_DEV = 'showMessageInDev',
  MESSAGE_ID = 'messageId',
  HEADER_TEXT = 'headerText',
  DESCRIPTION_TEXT = 'descriptionText',
  URL_HEADER_TEXT = 'urlHeaderText',
  NO_URL_TEXT = 'noUrlText',
  URL_BUTTON_TEXT = 'urlButtonText',
  URL_LINK = 'urlLink',
  DISPLAY_URL = 'displayUrl',
  QR_CODE_IMAGE_URL = 'qrCodeImageUrl',
  DISMISS_BUTTON_TEXT_MOBILE = 'dismissButtonTextMobile',
  DISMISS_BUTTON_TEXT_CTV = 'dismissButtonTextCtv',
  WEB_MESSAGE_BACKGROUND_COLOR = 'webMessageBackgroundColor',
  WEB_MESSAGE_TEXT_COLOR = 'webMessageTextColor',
  WEB_MESSAGE_HEIGHT_PERCENT = 'webMessageHeightPercent',
}
